import { useState } from "react";

export default function SingleQuestionItem({question,isFirst=false}) {

    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
        <div className={`${isFirst ? '' : 'border-t-[1px] border-grey-200'} py-[15px]`}>
            <div className="flex flex-nowrap">
                <div className={`w-[calc(100%-30px)] cairo-font text-[20px] text-grey-900 ${isOpen ? 'font-[700]' : 'font-[500]'}`}>{question?.question}</div>
                <div className="w-[30px] text-end">
                    <div className="inline-block w-[24px] h-[24px] align-middle cursor-pointer select-none" style={{background:isOpen ? 'url("/assets/images/minus-square-icon.svg")' : 'url("/assets/images/add-square-icon.svg")'}} onClick={()=>setIsOpen(!isOpen)}></div>
                </div>
            </div>
            <div className={`${isOpen ? 'pt-[15px] h-auto' : 'h-0'} overflow-hidden text-[18px] cairo-font text-grey-600 font-[500]`}>{question?.answer}</div>
        </div>
        </>
    )
}